import { DISPATCH_METHODS } from '@constants/servicejob';
import { FormattedMessage } from 'react-intl';
import { useServiceProvider } from '../../../../providers/ServiceProviderProvider';
import CalendarFlow from './CalendarFlow';
import CSRForm from './CSRForm';

function AssignJobFlow({
  serviceJob,
  isAssign,
  isReAssign,
  location,
  dispatchEvent,
  onClose,
}) {
  const { dispatchMethod, serviceProvider } = useServiceProvider();

  if (
    dispatchMethod?.dispatchMethod ===
    DISPATCH_METHODS.PRESET_CALENDAR_BASED_SCHEDULING
  ) {
    return (
      <CalendarFlow
        serviceJob={serviceJob}
        location={location}
        serviceProvider={serviceProvider}
      />
    );
  }

  if (
    dispatchMethod?.dispatchMethod === DISPATCH_METHODS.RESPONSIVE_INTEGRATION
  ) {
    return (
      <CSRForm
        onClose={onClose}
        serviceJob={serviceJob}
        isAssign={isAssign}
        isReAssign={isReAssign}
        location={location}
        dispatchEvent={dispatchEvent}
      />
    );
  }

  return (
    <FormattedMessage
      id="NO_VALID_DISPATCH_METHOD_FOUND"
      defaultMessage="No valid dispatch method found"
    />
  );
}

export default AssignJobFlow;
